export const getEligibleDate = (
  minDate?: "today" | string,
  maxDate?: "today" | string,
  dateTrip?: string,
  dateReturn?: string
) => {
  const now = getNewDate();

  let minDateEver = getNewDate();
  minDateEver.setFullYear(minDateEver.getFullYear() - 110);

  let maxDateEver = getNewDate();
  maxDateEver.setFullYear(maxDateEver.getFullYear() + 5);

  let minDateAvailable;

  switch (minDate) {
    case "today":
      minDateAvailable = now;
      break;
    case "dateTrip":
      minDateAvailable = dateTrip ? getNewDate(dateTrip) : now;
      break;
    default:
      minDateAvailable = minDateEver;
      break;
  }

  let maxDateAvailable;

  switch (maxDate) {
    case "today":
      maxDateAvailable = now;
      break;
    case "dateReturn":
      maxDateAvailable = dateReturn ? getNewDate(dateReturn) : maxDateEver;
      break;
    default:
      maxDateAvailable = maxDateEver;
      break;
  }

  return {
    minDateAvailable,
    maxDateAvailable,
  };
};

const ISO_REGEX = /^\d{4}-\d{2}-\d{2}(?:T.*)?$/;
const getNewDate = (date?: string): Date => {
  let d: Date;
  if (!date) {
    d = new Date(); // today local
  } else if (ISO_REGEX.test(date)) {
    // YYYY-MM-DD → safe
    const [y, m, day] = date.split("T")[0].split("-").map(Number);
    d = new Date(y, m - 1, day);
  } else {
    // MM/DD/YYYY safe
    const [mm, dd, yyyy] = date.split("/").map(Number);
    d = new Date(yyyy, mm - 1, dd);
  }
  d.setHours(0, 0, 0, 0); // safe today
  return d;
};
